module.exports = __webpack_public_path__ + "img/cryptocurrency-platform-4.c24e3916.jpg";